'use client';

import {
    useRouter as useNextRouter,
    redirect as nextRedirect,
    RedirectType,
} from 'next/navigation';
import { useState } from 'react';
import { BProgress } from '@bprogress/core';
import { useNavigationEvent } from '../useNavigationEvent';

interface PushOptions {
    scroll?: boolean;
}

export const useRouter = () => {
    const nextRouter = useNextRouter();
    const nextPush = (url: string, options?: PushOptions) => nextRouter.push(url, options);
    const routerMethods = { ...nextRouter, push: nextPush };

    const { push: _, ...restRouterMethods } = routerMethods;

    const [isRedirecting, setIsRedirecting] = useState(false);

    const onPushingEventStart = () => {
        setIsRedirecting(true);
        BProgress.start();
    };

    useNavigationEvent(() => {
        setIsRedirecting(false);
        BProgress.done();
    });

    const redirect = (url: string, type?: RedirectType) => {
        setIsRedirecting(true);
        nextRedirect(url, type);
    };

    const push = (url: string, options: PushOptions | undefined = undefined) => {
        onPushingEventStart();
        nextPush(url, options);
    };

    return {
        redirect,
        push,
        isRedirecting,
        ...restRouterMethods,
    };
};
